var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component"},_vm._l((_vm.items),function(item,index){return _c(_vm.itemTag,{key:index,tag:"component",class:_vm.itemClass},[_vm._v(_vm._s(item))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }